<template>
  <div class="WordSection1" >
    <p class="MsoNormal" style="text-align:center">
      <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-1 Satellite</span
      >
    </p>
    <hr class="divider" />
    <p
      class="MsoNormal"
      align="center"
      style="text-align:center"
    >
      <img
          width="441"
          height="264"
          id="图片 1"
          src="../../assets/gf1sat.png"
          alt="GF1"
      />
    </p>

     <p class="MsoNormal mt-4" style="text-indent:21.0pt">
      <span lang="EN-US" style='font-family:"Arial",sans-serif'
        >GF-1 satellite was successfully launched on April 26, 2013. The leading
        user is Ministry of Natural Resources of China. Other users include
        Ministry of Agriculture and Rural Affairs, and Ministry of Ecology and
        Environment etc. The satellite is equipped with two 2m resolution
        panchromatic/8m resolution multispectral cameras and four 16m resolution
        multispectral cameras.
      </span>
    </p>

    <p class="MsoNormal" style="text-indent:21.0pt">
      <span lang="EN-US" style='font-family:"Arial",sans-serif'
        >GF-1 satellite breaks through the optical remote sensing technology of
        combining high spatial resolution, multi-spectral with high temporal
        resolution, multi-sensor image mosaic and fusion technology, high
        precision stability and attitude control technology, realizes the
        synthesis of high resolution and wide swath imaging on a single
        satellite at the same time with the scene width of more than 60 km at 2
        m high resolution, and realizes a wide imaging of more than 800 km at
        16m resolution. It can meet the comprehensive needs of multi-temporal,
        multi-spectral and multi-source remote sensing data for different
        application requirements. It realizes the image positioning accuracy of
        50m without ground control points to meet user's precise application
        requirements. It also realizes the 2 x 450 Mbp data downlink
        transmission capability in small satellites to meet the needs of large
        data applications. The satellite can image at 35° side looking with high
        accuracy of attitude orientation and stability better than 5e-4°/s. For
        the first time, Its relay ability for measurement and control on
        domestic civilian small satellites can realize the measurement, control
        and management during overseas time periods.
      </span>
    </p>

    <p class="MsoNormal" style="margin-right:163.7pt;text-indent:21.0pt">
      <span lang="EN-US" style='font-family:"Arial",sans-serif'>&nbsp;</span>
    </p>

    <p class="MsoNormal" align="center" style="text-align:center">
      <b
        ><span lang="EN-US" style='font-family:"Arial",sans-serif'
          >Orbit parameters</span
        ></b
      >
    </p>

    <table
      class="MsoTableGrid"
      border="1"
      cellspacing="0"
      cellpadding="0"
      align="left"
      style="border-collapse:collapse;border:none;width:100%"
    >
      <tr style="height:15.25pt">
        <td
          width="206"
          valign="top"
          style="width:154.6pt;border:solid windowtext 1.0pt;
  background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <b
              ><span lang="EN-US" style='font-family:"Arial",sans-serif'
                >Item</span
              ></b
            >
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border:solid windowtext 1.0pt;
  border-left:none;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <b
              ><span
                lang="EN-US"
                style='font-family:"Arial",sans-serif;color:black'
                >Parameter</span
              ></b
            >
          </p>
        </td>
      </tr>
      <tr style="height:15.25pt">
        <td
          width="206"
          style="width:154.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Orbit</span
            >
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Sun-synchronous orbit</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:14.85pt">
        <td
          width="206"
          style="width:154.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:14.85pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Orbit altitude</span
            >
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.85pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >645 km</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:15.25pt">
        <td
          width="206"
          style="width:154.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Orbit inclination</span
            >
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >98.0506°</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:15.25pt">
        <td
          width="206"
          style="width:154.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Local time of descending node</span
            >
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:15.25pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >10:30 am</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:30.1pt">
        <td
          width="206"
          style="width:154.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:30.1pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Side swing capability (rolling)
            </span>
          </p>
        </td>
        <td
          width="677"
          valign="top"
          style="width:507.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:30.1pt"
        >
          <p class="MsoNormal">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >±25&ordm;, The maneuvering time is less than 200 seconds for 25°.
              It has the emergency side swing (rolling) ability of±35&ordm;.
            </span>
          </p>
        </td>
      </tr>
    </table>

    <p class="MsoNormal">
      <b
        ><span lang="EN-US" style='font-family:"Arial",sans-serif'
          >&nbsp;</span
        ></b
      >
    </p>

    

   
    <p class="MsoNormal" align="center" style="text-align:center">
      <b
        ><span lang="EN-US" style='font-family:"Arial",sans-serif'
          >Sensor technical parameters</span
        ></b
      >
    </p>

    <table
      class="MsoTableGrid"
      border="1"
      cellspacing="0"
      cellpadding="0"
      align="left"
      style="border-collapse:collapse;border:none;width:100%"
    >
      <tr>
        <td
          width="243"
          style="width:182.4pt;border:solid windowtext 1.0pt;background:
  #C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <b
              ><span lang="EN-US" style='font-family:"Arial",sans-serif'
                >Parameter</span
              ></b
            >
          </p>
        </td>
        <td
          width="308"
          colspan="2"
          style="width:230.65pt;border:solid windowtext 1.0pt;
  border-left:none;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <b
              ><span
                lang="EN-US"
                style='font-family:"Arial",sans-serif;color:black'
                >GF(HR) camera</span
              ></b
            >
          </p>
        </td>
        <td
          width="339"
          colspan="2"
          style="width:253.9pt;border:solid windowtext 1.0pt;
  border-left:none;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <b
              ><span
                lang="EN-US"
                style='font-family:"Arial",sans-serif;color:black'
                >Wide-swath camera</span
              ></b
            >
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="243"
          rowspan="5"
          style="width:182.4pt;border:solid windowtext 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Spectral band</span
            >
          </p>
        </td>
        <td
          width="144"
          style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Panchromatic image</span
            >
          </p>
        </td>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.45</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.90 μm</span
            >
          </p>
        </td>
        <td
          width="147"
          style="width:110.6pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Panchromatic image</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>——</span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="144"
          rowspan="4"
          style="width:108.0pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Multispectral Image</span
            >
          </p>
        </td>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.45</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.52 μm</span
            >
          </p>
        </td>
        <td
          width="147"
          rowspan="4"
          style="width:110.6pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Multispectral Image</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.45</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.52 μm</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:4.5pt">
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:4.5pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.52</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.59 μm</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:4.5pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.52</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.59 μm</span
            >
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.63</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.69 μm</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.63</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.69 μm</span
            >
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.77</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.89 μm</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>0.77</span
            ><span
              style="font-family:
  宋体"
              >～</span
            ><span lang="EN-US" style='font-family:"Arial",sans-serif'
              >0.89 μm</span
            >
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="243"
          rowspan="2"
          style="width:182.4pt;border:solid windowtext 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>GSD</span>
          </p>
        </td>
        <td
          width="144"
          style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Panchromatic image</span
            >
          </p>
        </td>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>2 m</span>
          </p>
        </td>
        <td
          width="147"
          style="width:110.6pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Panchromatic image</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>——</span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          width="144"
          style="width:108.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Multispectral Image</span
            >
          </p>
        </td>
        <td
          width="164"
          style="width:122.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>8 m</span>
          </p>
        </td>
        <td
          width="147"
          style="width:110.6pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Multispectral Image</span
            >
          </p>
        </td>
        <td
          width="191"
          style="width:143.3pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >16 m</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:11.3pt">
        <td
          width="243"
          style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Swath width</span
            >
          </p>
        </td>
        <td
          width="308"
          colspan="2"
          style="width:230.65pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >60 km (Combining two cameras’ observation)</span
            >
          </p>
        </td>
        <td
          width="339"
          colspan="2"
          style="width:253.9pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >800 km (Combining four cameras’ observation)</span
            >
          </p>
        </td>
      </tr>
      <tr style="height:11.3pt">
        <td
          width="243"
          style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Site re-visit period with side swing</span
            >
          </p>
        </td>
        <td
          width="308"
          colspan="2"
          style="width:230.65pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >4 days</span
            >
          </p>
        </td>
        <td
          width="339"
          colspan="2"
          style="width:253.9pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'>——</span>
          </p>
        </td>
      </tr>
      <tr style="height:11.3pt">
        <td
          width="243"
          style="width:182.4pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >Site re-visit period without side swing</span
            >
          </p>
        </td>
        <td
          width="308"
          colspan="2"
          style="width:230.65pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >41 days</span
            >
          </p>
        </td>
        <td
          width="339"
          colspan="2"
          style="width:253.9pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.3pt"
        >
          <p class="MsoNormal" align="center" style="text-align:center">
            <span lang="EN-US" style='font-family:"Arial",sans-serif'
              >4 days</span
            >
          </p>
        </td>
      </tr>
    </table>

    <p class="MsoNormal">
      <b
        ><span lang="EN-US" style='font-family:"Arial",sans-serif'
          >&nbsp;</span
        ></b
      >
    </p>

    <b
      ><span
        lang="EN-US"
        style='font-size:10.5pt;font-family:"Arial",sans-serif'
        ><br clear="all" style="page-break-before:always" /> </span
    ></b>

    <p class="MsoNormal" align="center" style="text-align:center">
      <b
        ><span lang="EN-US" style='font-family:"Arial",sans-serif'
          >&nbsp;</span
        ></b
      >
    </p>

    <p class="MsoNormal"><span lang="EN-US">&nbsp;</span></p>
  </div>
</template>

<style scoped>
.MsoNormal {
  text-align: left;
}
</style>
